<template>
  <div id="app">
    <loading v-if="isLoading"/>
    <notifications :position="$i18n.locale==='ar'?'top left':'top right'"/>
    <SideMenu v-if="isLoggedInLayout"/>
    <div id="panel" v-bind:class="{'main-content' : isLoggedInLayout }">
      <TopNavbar v-if="isLoggedInLayout"/>
      <CrudHeader v-if="isLoggedInLayout"/>
      <div class="" v-bind:class="{'mt--6' : isLoggedInLayout && isBreadShow,'bg-primary' : isLoggedInLayout && addPrimaryColor,'container-fluid' : isLoggedInLayout && isContainerFluid}">
        <router-view />
      </div>
      <div class="container-fluid" v-if="isLoggedInLayout">
        <MainFooter/>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from "./components/layout/SideMenu";
import TopNavbar from "./components/layout/TopNavbar";
import CrudHeader from "./components/crud/CrudHeader";
import MainFooter from "./components/layout/MainFooter";
import {mapGetters, mapState} from "vuex";
export default {
  components: {
    MainFooter,
    CrudHeader,
    TopNavbar,
    SideMenu
  },
  computed: {
    ...mapGetters(['isBreadShow','addPrimaryColor','isContainerFluid','isAuthenticated','isAuthenticated']),
    ...mapState({
      isLoading: state => state.isLoading,
    }),
  },
  data: function() {
    return {
      isLoggedInLayout: false,
    }
  },
  updated: function() {
    this.isLoggedInLayout=this.isLoggedInLayoutLogic();
  },
  created: function() {
    this.$notification.requestPermission();
    this.isLoggedInLayout=this.isLoggedInLayoutLogic();
  },
  methods:{
    isLoggedInLayoutLogic(){
      return this.isAuthenticated && typeof this.$router.currentRoute.name !=='undefined' && this.$router.currentRoute.name !=='unauthorized';
    },
  }
};
</script>

<style lang="scss">
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
